import { useQuery } from "@tanstack/react-query";

import { getPlatformUserMembershipsStatus } from "api/methods";

const useDunningMembership = () => {
  const { data: userMemberships } = useQuery({ ...getPlatformUserMembershipsStatus.keyed() });

  const dunningMembership = userMemberships?.find(
    ({ canceled, dunningStage }) => !canceled && dunningStage > 0,
  );

  return {
    dunningMembership: {
      status: !!dunningMembership,
      id: dunningMembership?.id || "",
    },
  };
};

export default useDunningMembership;
